<template>
  <div class="box" :style="widthStyle" style="margin-left:0!important">
    <div style="margin: 5px 0">
      <div class="flex-row start top list-half">
        <div class="video-box flex-column middle center" v-if="IsVideo">
          <div class="video flex-column middle center" v-if="Data">
            <div class="wf flex-row middle center" style="width:100%;height:100%">
              <video :src="getFullPath(Data)" controls class="video" ref="dialogVideo" width="100%" v-if="Data"></video>
              <i class="el-icon-video-play" style="font-size:40px;color:#eee;" v-else></i>
            </div>
          </div>
          <div v-else>
            <i class="el-icon-video-play" style="font-size:40px;color:#eee;"></i>
          </div>
        </div>
        <div class="file-box flex-column middle center" v-else>
          {{ Data }}
        </div>
        <div class=''>
          <el-upload v-show="showUpload && !uploading" :action="Url" :headers="Headers" list-type="text"
            :show-file-list="false" :on-success="onSuccess" :before-upload="onBeforeUpload"
            :disabled="disabled || config.Disabled" :on-progress="onProgress">
            <div style="text-align: left">
              <template v-if="Data">
                <el-button plain size='small'>重新上传</el-button>
              </template>
              <template v-else>
                <el-button plain size='small'>点击上传</el-button>
              </template>
              <div class="line2" style="color: #999; font-size: 12px;margin-top:10px;">
                {{ Info }}
              </div>
            </div>
          </el-upload>
        </div>
        <div v-show="uploading">
          <el-progress type="circle" :percentage="percentage" :width='42'></el-progress>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import upload from './upload.js'
import base from 'matrix.node.ui/field.js'
export default {
  mixins: [base.edit(String), upload],
  props: {
    value: String
  },
  computed: {

    IsVideo() {
      if (this.config && this.config.Exts) {
        let res = this.config.Exts.find(item => {

          return [".mp4", ".mp3", ".avi"].indexOf(item) > -1
        })
        if (res) return true
        return false
      }
    }
  },
  created() { }
}
</script>
<style scoped>
.box {
  width: 100%;
  text-align: left;
 
}

.video-box {
  width: 211px;
  height: 112px;
  background: #f7f8f9;
}

.video {
  background: #4789fc;
  height: 100%;
  align-items: center;
  justify-content: center;
  line-height: 100%;
}
</style>
